import { render } from "./DashboardByVersion.vue?vue&type=template&id=f5ed5fa2"
import script from "./DashboardByVersion.vue?vue&type=script&lang=js"
export * from "./DashboardByVersion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__